import React, { Component } from 'react'

class BrokerInfo extends Component {
    render(){
        let listData = []

        const { person, company } = this.props

        const broker = person?.broker || company?.broker

        if(broker){
            if(broker.firstName || broker.lastName){
                listData.push({
                    icon: 'person',
                    value: `${broker.firstName || ''} ${broker.lastName || ''}`.trim()
                })
            }

            if(broker.email){
                listData.push({
                    icon: 'message',
                    value: broker.email
                })
            }

            if(broker.phone){
                listData.push({
                    icon: 'phone',
                    value: broker.phone
                })
            }
        }

        return (
            <div className="content-box">
                <h3>
                    Broker
                </h3>
                <ul className="widget-list">
                    {listData.map((item, index) => {
                        return (
                            <li key={index}>
                                <img src={`/images/icons/${item.icon}.png`} />
                                <span>
                                    {item.value ? item.value : null}
                                </span>
                            </li>
                        )
                    })}
                </ul>
            </div>
        )
    }
}

export default BrokerInfo